<script setup lang="ts">
import { MapContainerAsync as MapContainer } from "./MapContainerAsync";
import type { MapPosition } from "./types";

const position = defineModel<MapPosition>({ required: true });

// Initial position only; the map is not re-centered while the user moves it.
const mapOptions = { ...position.value };
</script>

<template>
  <div class="map-position-picker">
    <MapContainer :options="mapOptions" @position-change="position = $event" />
  </div>
</template>

<style scoped>
.map-position-picker {
  block-size: 20rem;
}
</style>
